const BusinessInfoWhiteBg = () => {
  return (
    <div className="bg-[#fff] px-2">
      <h2 className="text-md font-semibold text-gray-800 mb-4">사업자 정보</h2>
      <div className="text-gray-700 text-xs">
        <p className="mb-2">
          <span className="font-bold">상호: </span>
          주식회사 마히
        </p>
        <p className="mb-2">
          <span className="font-bold">대표자: </span>
          원요한
        </p>
        <p className="mb-2">
          <span className="font-bold">사업자등록번호: </span>
          567-81-03232
        </p>
        <p className="mb-2">
          <span className="font-bold">통신판매업: </span>
          2026-수원팔달-0182
        </p>
        <p className="mb-2">
          <span className="font-bold">유선번호: </span>
          010-2819-1342
        </p>
        <p className="mb-2">
          <span className="font-bold">사업장: </span>
          경기도 수원시 팔달구 효원로 1, 사회혁신공간 505호
        </p>
      </div>
    </div>
  );
};
export default BusinessInfoWhiteBg;
